import axiosInstance from './axios';

export interface Shift {
    id: string;
    numero: string;
    apertura: string;
    cierre?: string;
    montoInicial: number;
    efectivo: number;
    tarjeta: number;
    qr: number;
    transferencia?: number;
    gastos: number;
    total: number;
    efectivoContado?: number;
    diferencia: number;
    observaciones?: string;
    status: 'ABIERTO' | 'CERRADO';
    /** Ventas de la tienda en el turno (ya incluidas en efectivo/tarjeta/qr/transferencia) */
    ventasTienda?: number;
    sede?: { id: string; nombre: string } | null;
}

export interface OpenShiftData {
    montoInicial: number;
}

export interface CloseShiftData {
    efectivoContado: number;
    tarjetaContada?: number;
    qrContado?: number;
    transferenciaContada?: number;
    observaciones?: string;
}

export interface ShiftDetails extends Shift {
    totalEfectivo: number;
    totalTarjeta: number;
    totalTransferencia: number;
    totalQr: number;
    transacciones: number;
    totalGastos: number;
    totalTienda?: number;
    totalEsperado: number;
}

export const getCurrentShift = async (): Promise<Shift | null> => {
    const response = await axiosInstance.get<Shift>('/shifts/current');
    return response.data;
};

export const getShiftDetails = async (): Promise<ShiftDetails | null> => {
    const response = await axiosInstance.get<ShiftDetails>('/shifts/details');
    return response.data;
};

export const getShiftDetailsByAdmin = async (shiftId: string): Promise<ShiftDetails | null> => {
    const response = await axiosInstance.get<ShiftDetails>(`/shifts/details/${shiftId}`);
    return response.data;
};

export const openShift = async (data: OpenShiftData): Promise<Shift> => {
    const response = await axiosInstance.post<Shift>('/shifts/open', data);
    return response.data;
};

export const closeShift = async (data: CloseShiftData): Promise<Shift> => {
    const response = await axiosInstance.post<Shift>('/shifts/close', data);
    return response.data;
};

export const closeShiftByAdmin = async (shiftId: string, data: CloseShiftData): Promise<Shift> => {
    const response = await axiosInstance.post<Shift>(`/shifts/close/${shiftId}`, data);
    return response.data;
};

export const getShiftsHistory = async (): Promise<Shift[]> => {
    const response = await axiosInstance.get<Shift[]>('/shifts');
    return response.data;
};
